import { FieldValues, UseFormSetError } from 'react-hook-form';

import { handleErrorForm } from '@services/api';

import {
  BudgetTemplateFilters,
  create,
  list,
  listAll,
  remove,
  retrieve,
  update,
} from './calls';
import { BudgetTemplate } from 'interfaces/BudgetTemplate';

export * from './calls';

export default class BudgetTemplateAPICaller {
  static list = async () => {
    const {
      data: { budgetTemplates },
    } = await list();

    return {
      ...budgetTemplates,
      result: budgetTemplates.result,
    };
  };

  static listAll = async (filters: BudgetTemplateFilters) => {
    const {
      data: { budgetTemplates },
    } = await listAll(filters);

    return {
      ...budgetTemplates,
      result: budgetTemplates.result,
    };
  };

  static fetch = async (editId: string) => {
    const {
      data: { budgetTemplate },
    } = await retrieve(editId);

    return budgetTemplate;
  };

  static createOrUpdate = async (
    data: FieldValues,
    setError: UseFormSetError<FieldValues>
  ) => {
    const method = data.id ? update : create;

    const result = method(data as BudgetTemplate).catch(
      handleErrorForm(setError)
    );

    return result;
  };

  static remove = async (id: string) => {
    const { data } = await remove(id);

    return data;
  };
}
